import React from 'react';
import { CTABlock } from './CTABlock';
export function EmotionalClose() {
  return <section className="bg-chocolate-900 text-chocolate-50 py-24 px-4" data-id="element-28">
      <div className="max-w-3xl mx-auto text-center space-y-8 text-lg md:text-xl leading-relaxed" data-id="element-29">
        <p className="text-2xl md:text-3xl font-bold" data-id="element-30">
          🍫 Disfrutar tu avance puede ser más simple
        </p>

        <p data-id="element-31">
          No necesitás más restricciones. No necesitás más culpa después de
          comer.
        </p>

        <p data-id="element-32">
          Necesitás un sistema que hackee tu biología, no que pelee contra ella.
        </p>

        <div className="pt-4" data-id="element-33">
          <CTABlock className="w-full md:w-auto text-lg md:text-xl" data-id="element-34">
            ACCEDÉ AHORA AL SISTEMA COMPLETO
          </CTABlock>
        </div>
      </div>
    </section>;
}